/** Shared modal header + close button layout (admin portal). */
export const MODAL_HEADER_LAYOUT_CLASS =
	"flex items-center justify-between gap-3 min-h-[5rem] flex-shrink-0";

/** Primary brand header band — applied to all standard modals. */
export const MODAL_HEADER_SURFACE_CLASS = "bg-primary text-primary-foreground px-5 py-5 shrink-0";

export const MODAL_TITLE_CLASS = "text-lg font-semibold text-primary-foreground leading-snug sm:text-xl";

export const MODAL_HEADER_BACK_BUTTON_CLASS =
	"-ml-1 rounded-full p-1 text-primary-foreground transition-colors hover:bg-white/15";

/** Circular light close control — matches app modal reference (gray disc + dark X). */
export const MODAL_CLOSE_BUTTON_CLASS =
	"inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-black/10 bg-[#f3f3f3] text-[#161616] shadow-[0_1px_2px_rgba(15,23,42,0.08)] transition-colors hover:bg-white hover:border-black/15 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/50";

export const MODAL_CLOSE_BUTTON_OVERLAY_CLASS =
	"absolute top-4 right-4 z-10 inline-flex h-10 w-10 items-center justify-center rounded-full border border-black/10 bg-[#f3f3f3] text-[#161616] shadow-[0_1px_2px_rgba(15,23,42,0.08)] transition-colors hover:bg-white hover:border-black/15 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/50";

export const MODAL_CLOSE_ICON_SIZE = 20;

export const MODAL_BODY_DEFAULT_PADDING = "p-6";

/** Body when a footer is present — symmetric vertical padding; footer sits flush below (no extra gap). */
export const MODAL_BODY_WITH_FOOTER_PADDING = "px-6 py-6";

/** Footer band — horizontal + bottom padding only. */
export const MODAL_FOOTER_PADDING = "px-6 pb-6 pt-0";

/** Footer when body uses `p-0` — matches header horizontal inset (`px-5` / `px-6`). */
export const MODAL_FOOTER_PADDING_WHEN_ZERO_BODY = "px-5 pb-5 sm:px-6 sm:pb-6 pt-0";

export const isStandardModalPadding = (padding: string): boolean =>
	padding === "p-6" || padding === MODAL_BODY_DEFAULT_PADDING;

/** @deprecated Header is full-width; use MODAL_BODY_DEFAULT_PADDING on body instead. */
export const MODAL_HEADER_INSET_WHEN_ZERO_PADDING = "px-5 pt-4";
